module.exports = "../study/imgs/maps/Kanagawa/S8/Climate/Temperture/Kanagawa_Temperture_GFDL_RCP85_Mid.png";